const b64DecodeUnicode = (str: string): string => {
  return decodeURIComponent(atob(str).replace(/(.)/g, (_m, p) => {
    let code = p.charCodeAt(0).toString(16).toUpperCase()
    if (code.length < 2) {
      code = `0${code}`
    }
    return `%${code}`
  }))
}

const decode = (str: string): string => {
  const output = str.replace(/-/g, '+').replace(/_/g, '/')
    .padEnd(str.length + (4 - str.length % 4) % 4, '=')
  try {
    return b64DecodeUnicode(output)
  }
  catch (_) {
    return atob(output)
  }
}

export const jwtDecode = (token: string, options?: { header: boolean }): Record<string, any> => {
  if (typeof token !== 'string') {
    throw new Error('Invalid token specified')
  }

  const pos = options?.header === true ? 0 : 1
  try {
    return JSON.parse(decode(token.split('.')[pos]))
  }
  catch (e) {
    const msg = e instanceof Error ? e.message : String(e)
    throw new Error(`Invalid token specified: ${msg}`)
  }
}
